<template>
    <div>
        <div class="tabs-header">
            <div class="tab-title" :class="{active: tab === active}" v-for="tab in tabs" @click="setActive(tab)">
                {{tab}}
            </div>
        </div>
        <div class="tabs-container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "tabType",
        data() {
            return {
                tabs: [],
                active: ''
            }
        },
        created() {
            this.$on('setActive',this.setActive);
            this.$nextTick(()=>{
                this.active = this.tabs[0];
            })
        },
        methods: {
            addTab($this) {
                this.tabs.push($this.title)
            },
            setActive(title){
                this.active = title;
            }
        },

    }
</script>

<style lang="scss" scoped>
    .tabs-header{
        background: #eee;
        width: 100%;
        text-align: center;
        .tab-title{
            display: inline-block;
            position: relative;
            margin: 5px 10px;
            user-select: none;
            cursor: pointer;
            &.active{

                &:after{
                    content: ' ';
                    display: block;
                    background: #EC7A5C;
                    height: 1px;
                    width: 100%;
                }
            }
        }
    }
    .tabs-container{
        margin-bottom: 20px;
    }
</style>